import { createContext, useContext, useEffect } from "react";
import useHelpers from "@hooks/useHelpers";
var FullPageContext = /*#__PURE__*/createContext();
export function useFullPageData() {
  var pageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  if (__IS_CSR__ && pageName && (!window.FULL_PAGE_DATA || window.ROUTE_NAME !== pageName)) {
    navigateToHard(window.location.href);
    return null;
  }
  useEffect(function () {
    return function () {
      window.FULL_PAGE_DATA = null;
    };
  }, []);
  if (__IS_CSR__ && window.FULL_PAGE_DATA) {
    return window.FULL_PAGE_DATA;
  }
  return useContext(FullPageContext);
}
export default FullPageContext;